import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-phone',
  imports: [],
  templateUrl: './phone.html',
  styleUrl: './phone.scss',
})
export class Phone {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
